if(!customElements.get('collection-user-columns')) {
  class CollectionUserColumns extends HTMLElement {
    constructor() {
      super();
      this.productGrid = document.querySelector('#product-grid');
      if (!this.productGrid) return;
      this.columnButtons = this.querySelectorAll('.collection-user-columns__btn');
      this.layout = this.dataset.layout;

      const defaultMobile = +(this.productGrid.dataset.colMobile || 2);
      const defaultTablet = +(this.productGrid.dataset.colTablet || 2);
      let defaultDesktop = defaultTablet;
      this.productGrid.classList.forEach((c) => {
        if (c.includes('-col-desktop')) {
          const n = +c.replace(`${this.layout}--`, '').replace('-col-desktop', '');
          if (!isNaN(n)) defaultDesktop = n;
        }
      });

      this.mobileColumns = +(sessionStorage.getItem('collection-columns-mobile') || defaultMobile);
      this.tabletColumns = +(sessionStorage.getItem('collection-columns-tablet') || defaultTablet);
      this.desktopColumns = +(sessionStorage.getItem('collection-columns-desktop') || defaultDesktop);

      this.applyView();

      this.columnButtons.forEach((button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      });

      window.addEventListener('resize', this.onResize.bind(this));
    }

    currentBreakpoint() {
      if (window.innerWidth >= 990) return 'desktop';
      if (window.innerWidth >= 750) return 'tablet';
      return 'mobile';
    }

    onButtonClick(event) {
      const cols = +(event.currentTarget.getAttribute('attr-col'));
      const bp = this.currentBreakpoint();

      if (bp === 'mobile') {
        this.mobileColumns = cols;
        sessionStorage.setItem('collection-columns-mobile', cols);
      } else if (bp === 'tablet') {
        this.tabletColumns = cols;
        sessionStorage.setItem('collection-columns-tablet', cols);
        if (cols > this.desktopColumns) {
          this.desktopColumns = cols;
          sessionStorage.setItem('collection-columns-desktop', cols);
        }
      } else {
        this.desktopColumns = cols;
        sessionStorage.setItem('collection-columns-desktop', cols);
        if (cols < this.tabletColumns) {
          this.tabletColumns = cols;
          sessionStorage.setItem('collection-columns-tablet', cols);
        }
      }

      this.productGrid = document.querySelector('#product-grid');
      this.applyView();
    }

    applyView() {
      const grid = this.productGrid;
      const layout = this.layout;
      const colPattern = new RegExp(`^${layout}--\\d+-col(-tablet|-desktop)?$`);

      [...grid.classList].forEach((c) => {
        if (colPattern.test(c)) grid.classList.remove(c);
      });

      grid.classList.add(`${layout}--${this.mobileColumns}-col`);

      const maxTablet = +(grid.dataset.colTablet || this.tabletColumns);
      const effectiveTablet = Math.min(this.tabletColumns, maxTablet);
      grid.classList.add(`${layout}--${effectiveTablet}-col-tablet`);

      grid.classList.add(`${layout}--${this.desktopColumns}-col-desktop`);

      this.updateActiveClasses();
    }

    updateActiveClasses() {
      this.columnButtons.forEach((button) => {
        const col = +(button.getAttribute('attr-col'));
        button.classList.toggle('mobile-active', col === this.mobileColumns);
        button.classList.toggle('tablet-active', col === this.tabletColumns);
        button.classList.toggle('desktop-active', col === this.desktopColumns);
      });
    }

    onResize() {
      this.updateActiveClasses();
    }
  }

  customElements.define('collection-user-columns', CollectionUserColumns);
}
